import { Delete, EditSharp } from "@mui/icons-material";
import { Menu, MenuItem } from "@mui/material";

type Props = {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onEdit: () => void;
  onDelete: () => void;
};

export default function CrmRowActionMenu({
  anchorEl,
  onClose,
  onEdit,
  onDelete,
}: Props) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            width: 182,
            borderRadius: "8px",
            boxShadow:
              "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)",
            overflow: "hidden",
          },
        },
        list: {
          sx: {
            p: 0,
          },
        },
      }}
    >
      <MenuItem
        onClick={onEdit}
        sx={{
          minHeight: 40,
          px: 3,
          py: 1,
          gap: 1,
          fontSize: 16,
          fontWeight: 400,
          lineHeight: 1.4,
          color: "#25272C",
          "&:hover": { bgcolor: "#EDEEF1" },
        }}
      >
        <EditSharp sx={{ fontSize: 18 }} />
        Edit
      </MenuItem>
      <MenuItem
        onClick={onDelete}
        sx={{
          minHeight: 40,
          px: 3,
          py: 1,
          gap: 1,
          fontSize: 16,
          fontWeight: 400,
          lineHeight: 1.4,
          color: "#25272C",
          "&:hover": { bgcolor: "#EDEEF1" },
        }}
      >
        <Delete sx={{ fontSize: 18 }} />
        Delete
      </MenuItem>
    </Menu>
  );
}
